<div class="card qai-card p-4 mb-3 shadow-sm">
    <h5 class="fw-bold mb-3">Totale spazio occupato</h5>

    <div class="d-flex justify-content-end mb-2">
        <div class="placeholder-glow">
            @if (!loading()) {
                <span class="fw-bold">
                    {{ totalUsed() | byteConverter }} in uso su {{ totalAvailable() | byteConverter }} disponibili
                </span>
            } @else {
                <span class="placeholder" style="width: 30ch;"></span> 
            }
        </div>
    </div>

    <div class="progress custom-progress rounded-pill mb-3">
        @for (segment of segmentsWithPercentage(); track $index) {
        <div class="progress-bar" [style.width]="segment.percentage + '%'"
            [style.backgroundColor]="segment.color" [class.rounded-2]="!$last" [class.me-1]="!$last && segment.percentage > 1" [class.last-progress-bar]="$last">
            @if (segment.percentage > 1) {
            {{ segment.value | byteConverter }}
            }
        </div>
        }
    </div>

    <div class="d-flex gap-4 flex-wrap">
        @for (segment of segmentsWithPercentage(); track $index) {
        <div class="d-flex align-items-center gap-2">
            <span class="legend-box" [style.backgroundColor]="segment.color"></span>
            <span class="small">{{ segment.label }} ({{ segment.percentage > 0.1 ? (segment.percentage | number:'1.1-1') : '< 0.1' }} %)</span>
        </div>
        }
        @if (loading()) {
        @for (segment of [1,2,3]; track $index) {
        <div class="d-flex align-items-center gap-2 placeholder-glow">
            <span class="legend-box placeholder"></span>
            <span class="small placeholder" style="width: 30ch;"></span>
        </div>
        }
        }
    </div>
</div>